export default "__VITE_ASSET__Cbah$UBd__"